import gql from "graphql-tag";

export const APPROVE_LOCATION_REFILL_REQUEST = gql`
  mutation ApproveLocationRefillRequest($id: Int!, $params: ApproveLocationRefillParams!) {
    approveLocationRefillRequest(id: $id, params: $params) {
      id
      status
    }
  }
`;

export const REJECT_LOCATION_REFILL_REQUEST = gql`
  mutation RejectLocationRefillRequest($id: Int!, $rejectionReason: String) {
    rejectLocationRefillRequest(id: $id, rejectionReason: $rejectionReason) {
      id
      status
    }
  }
`;
